import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { SideNavComponent } from '../side-nav/side-nav.component';

@Component({
  selector: 'app-layout-default',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, BottomNavComponent, SideNavComponent],
  templateUrl: './layout-default.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './layout-default.component.css',
})
export class LayoutDefaultComponent {}
